const ScrollButton = () => (
  <a
    href="https://wa.me/21627628111"
    target="_blank"
    rel="noreferrer"
    aria-label="WhatsApp"
    className="fixed bottom-24 right-4 z-[400] w-12 h-12 flex items-center justify-center rounded-full hover:scale-110 transition-transform duration-200 drop-shadow-lg"
  >
    <img src="/whatsapp.png" alt="whatsapp" className="w-12 h-12 object-contain" />
  </a>
);

export default ScrollButton;
